import {
  Box, Collapse, IconButton, Paper, Tooltip, Typography,
} from '@mui/material';
import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { EventFormStatus, FormMetadata } from '../../core/api/clients';
import { getColor } from '../../core/colors';
import DispatchEventList from './DispatchEventList';
import DispatchEventDrafts from './DispatchEventDrafts';
import useGetFormMetadata from '../../core/api/hooks/common/useGetFormMetadata';

function DispatchEventLanding({ formMetadata }:{ formMetadata: FormMetadata }) {
  if (!formMetadata || !(formMetadata.contributeRole)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  const { data: authorizedForm } = useGetFormMetadata(formMetadata.componentName ?? '');

  if (!authorizedForm) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  return (
    <React.Fragment>
      <Collapse in={authorizedForm.isContributor}>
        <Box>
          <Box display="flex" flexDirection="column">
            <Typography variant="h6" sx={{ mb: 0, color: getColor(formMetadata.color)[500], fontWeight: 300 }}>
              Your Drafts
            </Typography>
            <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
              <DispatchEventDrafts />
            </Paper>
          </Box>
          <Box margin={2} />
        </Box>
        <Box display="flex" flexDirection="column">
          <Typography variant="h6" sx={{ mb: 0, color: getColor(formMetadata.color)[500], fontWeight: 300 }}>
            All Submissions
            <Tooltip title="This section shows all forms in Submitted status, not yet approved.">
              <IconButton>
                <InfoOutlined />
              </IconButton>
            </Tooltip>
          </Typography>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <DispatchEventList
              statuses={[EventFormStatus.Submitted]}
              pageSize={10}
            />
          </Paper>
        </Box>
      </Collapse>
      <Collapse in={authorizedForm.isAdministrator || authorizedForm.isApprover || authorizedForm.isReader}>
        <Box display="flex" flexDirection="column">
          <Typography variant="h6" sx={{ mb: 0, color: getColor(formMetadata.color)[500], fontWeight: 300 }}>
            Dispatch Event Forms (Last 7 days)
            <Tooltip title="This section shows the forms from the last 7 days using the date the report was created.">
              <IconButton>
                <InfoOutlined />
              </IconButton>
            </Tooltip>
          </Typography>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <DispatchEventList
              statuses={[EventFormStatus.Submitted, EventFormStatus.Approved, EventFormStatus.Final]}
              pageSize={10}
              hours={168}
            />
          </Paper>
        </Box>
      </Collapse>
    </React.Fragment>
  );
}

export default DispatchEventLanding;
